export default __webpack_public_path__ + "static/media/theatre-roulette.d304b6f3.webp";